import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file popover弹框 + 自定义类型，type: 'number-range' | 'custom'
 * @author alfielv
 */
import _ from 'lodash';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { Icon, PopOver, OverlayTrigger } from '@tencent/spaui';
import FilterComponents from '../components';

var FilterPopover = function FilterPopover(props) {
  var name = props.name,
      type = props.type,
      customComponentRef = props.customComponentRef,
      title = props.title,
      config = props.config,
      value = props.value,
      onChange = props.onChange,
      onClear = props.onClear,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$defaultContent = props.defaultContent,
      defaultContent = _props$defaultContent === void 0 ? '' : _props$defaultContent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1]; // popover显示/隐藏


  var _useState3 = useState(defaultContent),
      _useState4 = _slicedToArray(_useState3, 2),
      content = _useState4[0],
      setContent = _useState4[1]; // 中文显示
  // 剥离中文内容，继续传递onChange


  var handleChange = useCallback(function (_ref) {
    var text = _ref.text,
        value = _ref.value;
    setContent(text);
    onChange === null || onChange === void 0 ? void 0 : onChange(value); // 关闭popover

    setShow(false);
  }, [onChange]); // 剥离中文内容，继续传递onClear

  var handleClear = useCallback(function () {
    setContent('');
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }, [onClear]); // value为空，置空content

  useEffect(function () {
    if (typeof value === 'undefined') {
      setContent('');
    }
  }, [value]); // filter组件

  var filterComponent = useMemo(function () {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var FilterComponent = FilterComponents[type] || _.get(customComponentRef, 'current');

    if (!FilterComponent) {
      console.error('ERROR in ListView component: No FilterComponent found, please check again.');
    }

    return /*#__PURE__*/React.createElement(FilterComponent, {
      config: config,
      value: value,
      onChange: handleChange,
      onClose: function onClose() {
        return setShow(false);
      }
    });
  }, [type, value, config, customComponentRef, handleChange]);
  return /*#__PURE__*/React.createElement("div", {
    id: "filter-item__".concat(name),
    className: classNames('filter-item', {
      'filter-item-active': show
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-item-key"
  }, title), /*#__PURE__*/React.createElement(OverlayTrigger, {
    autoResize: true,
    documentClickAutoHide: true,
    trigger: "click",
    overlay: /*#__PURE__*/React.createElement(PopOver, {
      className: "ptp-filter-control-popover"
    }, title && /*#__PURE__*/React.createElement("div", {
      className: "ptp-filter-control-popover__title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "ptp-filter-control-popover__body"
    }, filterComponent)),
    onShow: function onShow(_event, value) {
      return setShow(value);
    },
    show: show
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-item-val"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('filter-item-input', content ? '' : 'placeholder')
  }, content || '请设置筛选条件'), /*#__PURE__*/React.createElement("i", {
    className: "filter-item-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "dropdown-arrow-outlined",
    className: "meta-arrow"
  })))), clearable && /*#__PURE__*/React.createElement("span", {
    className: "filter-item-clear-btn",
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    className: "meta-clear"
  })));
};

export default FilterPopover;